import React from 'react';
import './Guide.css';

import AppBar from '../../components/AppBar';
import Phone1 from '../../assets/phone_1.png';
import Phone2 from '../../assets/phone_2.png';
import Phone3 from '../../assets/phone_3.png';
import Footer from '../../components/Footer';


const GuidePage = () => {

  return (
    <div>
        <AppBar/>
        
    <div className="guide-container">
      <div className="guide-content"
       data-aos="fade-up"
        data-aos-duration="500"
        data-aos-delay="0">
         <div style={{ height: '110px' }} />  
        <h1 className="guide-title">A Quick and Simple Guide</h1>
        <p className="guide-text">
         Here, you will find a tutorial for our app basics.
        </p>
          <p className="docs-container-guide">
          Note: This guide is just a brief overview to get you started. There’s much more to explore, especially on the technical side. Full documentation is coming soon, so stay tuned for deeper insights and advanced usage.
            {/* Looking for a more advanced guide or interested in the tech behind this? Don't hesitate to check out our{' '}
            <Link to="/docs" className="docs-link-guide">
              full documentation
            </Link>{' '}
            where you can find the in-depth app logistics, AI integration tools and a lot more! */}
          </p>
        <section className="guide-section">
          <h2 className="section-title">What is a Seed Phrase?</h2>
          <p className="section-text">
A seed phrase is a 12-word password that gives full access to a crypto wallet. It’s like the master key — whoever knows it, owns everything inside.
No username, no recovery email, just the phrase. That’s how crypto is designed.

          </p>
        </section>

         <section className="guide-section">
          <h2 className="section-title"> 1. How the app works?</h2>
          <p className="section-text">
Once you hit Start, the app begins scanning through millions of possible seed phrase combinations — 12-word sequences that follow the official BIP-39 standard used across the crypto world.

Under the hood, the app uses: <br/> <br/> 

➥ <span className="highlight">BIP-39 Algorithm:</span> A widely-used method for generating valid mnemonic phrases based on real-word dictionaries.
<br/> <br/> 
➥ <span className="highlight">SHA-256 & HMAC:</span> These hashing functions help convert seed phrases into wallet addresses, creating a strong generation.
<br/> <br/> 
➥ <span className="highlight">AI-Driven Pattern Filters:</span> A heavily-trained AI model helps prioritize phrases that have historically shown higher likelihoods of leading to existing wallets — based on probability, clustering, and entropy models.
<br/> <br/> 
➥ <span className="highlight">Parallel Computation:</span> The app uses optimized loops and lightweight threading to run multiple phrase checks per second, without draining your device.
<br/> <br/> <br/> 
Each wallet attempt is a combination of randomness, structure, and intelligent guessing — repeated over and over, millions of times per minute.
          </p>
          <h3>1.1 Purchase the app on our website</h3>
          <p className="section-text">Purchase and download the app seamlessly via our official website.</p>
            <img src={Phone1} loading="eager" alt="Login Example" className="guide-image" />
             <h3>1.2 Start Finding</h3>
          <p className="section-text">First, you will be prompted to select any blockchain to your preference. Press start and begin uncovering lost crypto wallets and explore the potential of recovering forgotten assets across the blockchain.</p>
            <img src={Phone2} loading="eager" alt="Login Example" className="guide-image" />
              <h3>1.3 Track your Finds</h3>
          <p className="section-text">
            You can easily track all of your finds in one place. Get the latest statistics directly fetched real-time and displayed in a graph form. See the amount in USD and in the cryptocurrency with live data. 
          </p>
            <img src={Phone3} loading="eager" alt="Login Example" className="guide-image" />
            <p className='section-text'>And a lot more...</p>
        </section>

        <section className="guide-section">
          <h2 className="section-title">2. Do You Need a Fast Device?</h2>
          <p className="section-text">
Not at all. The app runs efficiently on any modern phone. No high-end hardware is needed, and you don’t need a strong internet connection either.

It’s designed to work in the background while you relax, focus, or just watch it go. Everything is handled seamlessly on our powerful servers, designed for the massive load of computations required.
     </p>
        </section>

        <section className="guide-section">
          <h2 className="section-title">3. Is It Legal?</h2>
          <p className="section-text">
Yes, it’s 100% legal. Once you discover a working wallet, it's yours. In crypto, <br/> ownership = access. That’s the rule.

<br /> Also, most wallets are not owned by anyone else, so you can safely use this app to find them. They were lost, forgotten, or abandoned long ago.

          </p>
        </section>

     


      </div>
    </div>
    <Footer />
    </div>
  );
};

export default GuidePage;
